import React from "react";
import { ExternalLink, Paperclip } from "react-feather";
import { API_BASE } from "../../services/AxiosInstance";

/** Full URL for opening a chat attachment in a new tab. */
export function chatMessageAttachmentHref(item) {
  if (!item) return null;
  const fromApi = String(item.attachment_url || "").trim();
  if (fromApi) return fromApi;
  const rel = String(item.attachment || "").trim();
  if (!rel) return null;
  const base = API_BASE.replace(/\/?$/, "");
  return `${base}/${rel.replace(/^\//, "")}`;
}

export default function ChatMessageAttachment({ item }) {
  const href = chatMessageAttachmentHref(item);
  if (!href) return null;

  const fileLabel =
    String(item.attachment || "")
      .split("/")
      .filter(Boolean)
      .pop() || "Attachment";

  return (
    <div className="mt-2 pt-2 border-top border-light">
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className="d-inline-flex align-items-center gap-2 small fw-semibold text-decoration-none rounded-2 px-2 py-1"
        style={{
          background: "rgba(13, 110, 253, 0.08)",
          color: "#0d6efd",
          border: "1px solid rgba(13, 110, 253, 0.25)",
        }}
      >
        <Paperclip size={14} aria-hidden />
        <span className="text-truncate" style={{ maxWidth: 220 }} title={fileLabel}>
          {fileLabel}
        </span>
        <ExternalLink size={14} aria-hidden />
      </a>
    </div>
  );
}
